import React, { useEffect } from "react";
import { DialogContent } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import CloseButton from "../CloseButton";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import withDialogManager from "./withDialogManager";
import { get } from "lodash";
import { RichText } from "prismic-reactjs";

const StlDialogContent = styled(DialogContent)`
  padding: 24px 30px 8px;
  @media only screen and (max-width: 600px) {
    padding: 24px 16px 8px;
  }
  ul {
    padding-left: 10px;
    text-align: left;

    li {
      margin-bottom: 15px;
      @media only screen and (min-width: 1100px) {
        font-size: 18px;
      }
    }
  }
`;

const StlCloseButton = styled(CloseButton)`
  top: 5px;
  right: 5px;
  cursor: pointer;
`;

const StlPlaceholder = styled.div`
  width: 311px;
  height: 570px;
  overflow: none;
  overflow-y: none;
  @media only screen and (min-width: 1100px) {
    width: 552px;
    height: 350px;
  }
`;

function D9HempDialog() {
  const dispatch = useDispatch();

  const closeDialog = () => {
    dispatch({ type: "DIALOG/CLOSE" });
  };

  useEffect(() => {
    dispatch({
      type: "PRISMIC_LOAD_SINGLE_PAGE",
      key: "d9_dialog_copy",
    });
  }, [dispatch]);

  const copy = useSelector((state) =>
    get(state, "prismic.d9_dialog_copy.data.copy", false)
  );
  const copyLoading = useSelector((state) =>
    get(state, "prismic.d9_dialog_copy.loading", true)
  );

  return (
    <Dialog open={true} className="relative" maxWidth="sm">
      <StlDialogContent className="mb-10">
        {copyLoading ? (
          <StlPlaceholder></StlPlaceholder>
        ) : (
          <div className="text-center mt-15">
            <RichText render={copy} />
          </div>
        )}
      </StlDialogContent>
      <StlCloseButton
        onClick={closeDialog}
        className="absolute"
        aria-label="Close Popup"
      />
    </Dialog>
  );
}

export default withDialogManager("d9_hemp_dialog", D9HempDialog);
